import { render } from "./realer.vue?vue&type=template&id=5787aaaf"
import script from "./realer.vue?vue&type=script&lang=js"
export * from "./realer.vue?vue&type=script&lang=js"

import "./realer.vue?vue&type=style&index=0&id=5787aaaf&lang=less"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__